<template>
  <common
    :searchFrom="searchFrom"
    :tableTitle="tableTitle"
    :list="list"
    @crudClick="crudClick"
    :arrPageSize="arrPageSize"
    :total="total"
    :pageSize="searchFrom.pageSize"
    :BoolModal="isshowModal"
    :title="titleModal"
    @changeBindModal="changeBindModal"
    @closedeleteModal="closedeleteModal"
    :unChange="unChange"
    :footerHide="footerHide"
    :width="width"
    :inputType="1"
    :loading="loading"
    :listPage="true"
    @exportExc="exportExc"
    :isConfirmWeight="true"
    @operClick="operClick"
    :maskClosable="maskClosable"
    :current.sync="current"
    ref="common"
    @pageClick="getList"
    :orderText="pageText"
    :checkDate="true"
  >
    <template v-if="isOk" slot="oper">
      <FormItem>
        <Dropdown>
          <Button type="primary">
            {{ $t("print") }}
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem
              @click.native="print(item, index)"
              v-for="(item, index) in printType"
              :key="index"
            >
              {{ item[$i18n.locale] }}
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </FormItem>
    </template>
    <template v-if="isConfirmWeight" slot="recharge">
      <FormItem>
        <Button
          type="primary"
          :disabled="selectAll.length > 0 ? false : true"
          @click="confirmWeightFun"
        >
          {{ $t("confirmWeight") }}
        </Button>
      </FormItem>
    </template>
    <template slot="select">
      <FormItem class="search-date">
        <Select
          v-model="searchFrom.time_type"
          filterable
          clearable
          :placeholder="$t('select') + $t('date') + '类型'"
          :filter-by-label="true"
        >
          <Option
            v-for="item in timeType"
            :value="item.key"
            :key="item.key"
            :label="item.desc"
          ></Option>
        </Select>
      </FormItem>
      <FormItem v-if="isOk && pageText != 'orderIn'" class="search-size">
        <Select
          v-model="searchFrom.codeStatus"
          filterable
          clearable
          :placeholder="$t('select') + $t('orderType')"
          :filter-by-label="true"
        >
          <Option
            v-for="(item, index) in orderType"
            :value="item.code"
            :key="index"
            :label="item.remark"
            >{{ item.remark }}</Option
          >
        </Select>
      </FormItem>
      <FormItem v-if="pageText == 'orderIn'" class="search-size">
        <Select
          v-model="searchFrom.confirmStatus"
          filterable
          clearable
          :placeholder="$t('select') + $t('type')"
          :filter-by-label="true"
        >
          <Option
            v-for="(item, index) in confirmObj"
            :value="index"
            :key="index"
            :label="item[$i18n.locale]"
          ></Option>
        </Select>
      </FormItem>
      <FormItem class="search-date">
        <Select
          v-model="searchFrom.clientId"
          filterable
          clearable
          :placeholder="$t('select') + $t('clientName')"
          :filter-by-label="true"
        >
          <Option
            v-for="(item, index) in clientList"
            :value="item.id"
            :key="index"
            :label="item.account"
            >{{ item.account }}</Option
          >
        </Select>
      </FormItem>
      <FormItem class="search-date">
        <Select
          v-model="searchFrom.serviceId"
          filterable
          clearable
          :placeholder="$t('select') + $t('serviceAccount')"
          :filter-by-label="true"
        >
          <Option
            v-for="(item, index) in serviceList"
            :value="item.id"
            :key="index"
            :label="item.account"
            >{{ item.account }}</Option
          >
        </Select>
      </FormItem>
      <FormItem class="search-date">
        <Select
          v-model="searchFrom.salesmanId"
          filterable
          clearable
          :placeholder="$t('select') + $t('salesman')"
          :filter-by-label="true"
        >
          <Option
            v-for="(item, index) in salesmanList"
            :value="item.id"
            :key="index"
            :label="item.account"
            >{{ item.account }}</Option
          >
        </Select>
      </FormItem>
      <FormItem class="search-date">
        <Select
          v-model="searchFrom.trackerCode"
          filterable
          clearable
          :placeholder="$t('select') + '签收状态'"
          :filter-by-label="true"
        >
          <Option
            v-for="(item, index) in trackerObj"
            :value="index"
            :key="index"
            :label="item[$i18n.locale]"
            >{{ item[$i18n.locale] }}</Option
          >
        </Select>
      </FormItem>
      <FormItem class="search-date">
        <Select
          v-model="searchFrom.from_country"
          filterable
          clearable
          :placeholder="$t('select') + $t('allow_depart')"
          :filter-by-label="true"
        >
          <Option
            v-for="item in countryList"
            :value="item.code"
            :key="item.code"
            :label="item.title"
            >{{ item.title }}</Option
          >
        </Select>
      </FormItem>
      <FormItem class="search-date">
        <Select
          v-model="searchFrom.countryCode"
          filterable
          clearable
          :placeholder="$t('select') + $t('allow_arrive')"
          :filter-by-label="true"
        >
          <Option
            v-for="item in toCountry"
            :value="item.code"
            :key="item.code"
            :label="item.title"
            >{{ item.title }}</Option
          >
        </Select>
      </FormItem>
      <FormItem class="search-date">
        <Select
          v-model="searchFrom.type"
          filterable
          clearable
          :placeholder="$t('select') + '订单类型'"
          :filter-by-label="true"
        >
          <Option
            v-for="(item, index) in orderTypeList"
            :value="index"
            :key="item"
            :label="item"
          ></Option>
        </Select>
      </FormItem>
      <FormItem class="search-date">
        <Select
          v-model="searchFrom.codType"
          filterable
          clearable
          :placeholder="$t('select') + $t('order_type')"
          :filter-by-label="true"
        >
          <Option :value="'NCND'">NCND</Option>
          <Option :value="'NOR'">NOR</Option>
        </Select>
      </FormItem>
      <FormItem class="search-date" v-if="shouldBlock == 'CLIENT_REQUEST'">
        <Select
          v-model="searchFrom.interception_phase"
          filterable
          clearable
          placeholder="拦截阶段"
          :filter-by-label="true"
        >
          <Option
            :value="index"
            v-for="(item, index) in interceptionObj"
            :key="index"
            :label="item"
          ></Option>
        </Select>
      </FormItem>
      <FormItem class="search-date">
        <Select
          v-model="searchFrom.deliver"
          filterable
          clearable
          :placeholder="$t('select') + '地派'"
          :filter-by-label="true"
        >
          <Option
            v-for="item in deliverList"
            :key="item.id"
            :value="item.agent_name"
            :label="item.agent_name"
          ></Option>
        </Select>
      </FormItem>
      <template v-if="isAll">
        <FormItem class="search-date">
          <Select
            v-model="searchFrom.is_warehouse"
            filterable
            clearable
            :placeholder="$t('select') + $t('Overseasdistribution')"
            :filter-by-label="true"
          >
            <Option
              v-for="(item, index) in OverseasdList"
              :value="item.value"
              :key="index"
              :label="item.label"
            ></Option>
          </Select>
        </FormItem>
        <FormItem class="search-date">
          <Select
            v-model="searchFrom.warehouse_id"
            filterable
            clearable
            :placeholder="$t('select') + $t('warehouseName')"
            :filter-by-label="true"
          >
            <Option
              v-for="item in warehouseList"
              :value="item.id"
              :key="item.id"
              :label="item.code"
            ></Option>
          </Select>
        </FormItem>
      </template>
      <FormItem v-if="isWarehouse" class="search-date">
        <Select
          v-model="searchFrom.warehouse"
          filterable
          clearable
          :placeholder="$t('select') + $t('warehouseName')"
          :filter-by-label="true"
        >
          <Option
            v-for="item in warehouseArr"
            :value="item.id"
            :key="item.id"
            :label="item.code"
          ></Option>
        </Select>
      </FormItem>
      <FormItem class="search-date">
        <Select
          v-model="searchFrom.searchType"
          filterable
          placeholder="关键词类型"
          :filter-by-label="true"
        >
          <Option
            :value="index"
            v-for="(item, index) in searchTypeObj"
            :key="index"
            :label="item"
          ></Option>
        </Select>
      </FormItem>
    </template>
    <template slot="content">
      <template v-if="crudText != 'show'">
        <template v-if="crudText == 'planReturn'">
          <Form
            label-position="right"
            :model="dataDetails"
            :label-width="130"
            :rules="ruleFrom"
            ref="dataDetails"
          >
            <FormItem :label="$t('plan')" prop="plan">
              <Select
                v-model="dataDetails.plan"
                filterable
                clearable
                :placeholder="$t('select') + $t('plan')"
              >
                <Option
                  v-for="(item, index) in typeObj"
                  :value="index"
                  :key="index"
                  :label="item[$i18n.locale]"
                ></Option>
              </Select>
            </FormItem>
            <FormItem :label="$t('plan_remark')">
              <Input
                v-model="dataDetails.plan_remark"
                :placeholder="$t('enter') + $t('plan_remark')"
                type="textarea"
                :rows="4"
              >
              </Input>
            </FormItem>
          </Form>
        </template>
        <template v-else>
          <order-tracker
            :statusId="statusId"
            v-if="isshowModal"
          ></order-tracker>
        </template>
      </template>
      <template v-else>
        <order
          :orderDetails="dataDetails"
          :footer-hide="footerHide"
          :pageText="pageText"
        ></order>
      </template>
    </template>
  </common>
</template>
<script>
import {
  getOrderDetails,
  getOrder,
  getOrderStatus,
  getOrderType,
  postSheet,
  postPdf,
  returnPlan,
  getTimeType,
  confirmWeight
} from "@/api/order/list";
import { getUser } from "@/api/user/internal";
import { getCountry } from "@/api/system/country";
import { getAllClient } from "@/api/user/client";
import { getAgent } from "@/api/tracker/agent";
import { getWarehouse } from "@/api/storage/warehouse";

// import excel from "@/utils/excel";
import format from "@/utils/format";
import boxMes from "@/utils/message";
import copyClick from "@/utils/copyClick";

import common from "@/vxe-common/common";
import order from "_c/order-details";
import orderTracker from "@/base/order_tracker";

export default {
  props: {
    isConfirmWeight: {
      type: Boolean,
      default: false
    },
    isOk: {
      type: Boolean
    },
    isWarehouse: {
      type: Boolean,
      default: false
    },
    isAll: {
      type: Boolean,
      default: false
    },
    isPage: {
      type: Boolean,
      default: false
    },
    codeStatus: {
      type: Number,
      default: 0
    },
    pageText: {
      type: String
    },
    shouldBlock: {
      type: String
    }
  },
  components: {
    common,
    order,
    orderTracker
  },
  watch: {
    dataDetails: {
      handler: function(nowVal) {
        var $this = this;
        for (let i in $this.dataDetails) {
          if (nowVal[i] !== $this.preForm[i]) {
            $this.unChange = false;
            break;
          } else {
            $this.unChange = true;
          }
        }
      },
      deep: true
    }
  },
  data() {
    return {
      interceptionObj: {
        BeforePackage: this.$t("BeforePackage"),
        BeforePackageOutboun: this.$t("BeforePackageOutboun"),
        BeforeOverseaWarehouse: this.$t("BeforeOverseaWarehouse"),
        BeforeManifest: this.$t("BeforeManifest"),
        BeforeOverseaOutbound: this.$t("BeforeOverseaOutbound")
      },
      searchTypeObj: {
        airway_number: this.$t("order_number"),
        client_refer_code: this.$t("order_userRef"),
        agent_refer_code: this.$t("order_refCode")
      },
      orderTypeList: [
        "小包",
        "B2B",
        "合联",
        "亚马逊easyship",
        "NOON",
        "转单",
        "速卖通",
        "亚马逊selfship"
      ],
      toCountry: [],
      typeObj: {
        selfMention: { "zh-CN": "自提", "en-US": "selfMention" },
        sendExpress: { "zh-CN": " 寄快递", "en-US": "sendExpress" }
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      serviceList: [],
      salesmanList: [],
      current: 1,
      maskClosable: true,
      tableList: [],
      selectAll: [],
      showStatus: false,
      typeList: [],
      searchFrom: {
        page: 1,
        pageSize: 15,
        keywords: "",
        clientId: "",
        trackerCode: "",
        countryCode: "",
        codeStatus: "",
        startTime: "",
        endTime: "",
        should_block: "",
        confirmStatus: "",
        searchType: "airway_number"
      },
      // 详情模态框显示/隐藏
      isshowModal: false,
      // 数据详情
      dataDetails: {},
      // 删除模态显示/隐藏
      Delmodal1: false,
      // 模态框标题
      isshowModalTitle: "",
      disabled: false,
      footerHide: false,
      crudText: "",
      titleModal: "",
      deleteModal: false,
      delId: 0,
      preForm: {},
      unChange: true,
      orderDetails: {},
      printType: [
        {
          type: true,
          "zh-CN": "面单(100*100)",
          "en-US": "Label(100*100)"
        },
				{
				  type: false,
					specialLable:true,
				  "zh-CN": "面单(100*150)",
				  "en-US": "Label(100*150)"
				},
        {
          type: false,
          "zh-CN": "面单(100*200)",
          "en-US": "Label(100*200)"
        },
        {
          type: "Invoice",
          rule: "standard",
          "zh-CN": "发票",
          "en-US": "Invoice"
        }
      ],
      deliverList: [],
      warehouseList: [],
      warehouseArr: [],
      hideSelect: false,
      countryList: [],
      clientList: [],
      modalWidth: 0,
      arrPageSize: [15, 100, 500, 1000],
      width: 600,
      list: [],
      total: 0,
      loading: true,
      dateTime: [],
      orderType: [],
      ruleFrom: {
        plan: [
          {
            required: true,
            message: "cannot be empty",
            trigger: "change"
          }
        ],
        plan_remark: [
          {
            required: true,
            message: "cannot be empty",
            trigger: "blur"
          }
        ]
      },
      trackerObj: {
        POD: { "zh-CN": "已签收", "en-US": "POD" },
        EXCEPTION: { "zh-CN": " 异常", "en-US": "EXCEPTION" }
      },
      confirmObj: {
        confirmed: { "zh-CN": "已确认重量", "en-US": "confirmed" },
        unconfirmed: { "zh-CN": "未确认", "en-US": "unconfirmed" }
      },
      timeType: [],
      statusId: "",
      OverseasdList: [
        { value: 1, label: this.$t("YES") },
        { value: 2, label: this.$t("NO") }
      ]
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      if (this.hideSelect) {
        columns.push({
          title: this.$t("order_number"),
          key: "airway_number",
          minWidth: 180
        });
      }
      columns.push({
        title: this.$t("tracker_code"),
        key: "status",
        minWidth: 80
      });
      columns.push({
        title: this.$t("tracker_description"),
        key: "status_remarks",
        minWidth: 110
      });
      columns.push({
        title: this.$t("status_time"),
        key: "status_time",
        minWidth: 110
      });
      columns.push({
        title: "地派",
        key: "deliver",
        minWidth: 80
      });
      columns.push({
        title: this.$t("order_type"),
        key: "cod_type",
        minWidth: 80
      });
      if (this.shouldBlock == "CLIENT_REQUEST") {
        columns.push({
          title: "拦截阶段",
          key: "interception_phase_txt",
          minWidth: 80
        });
      }
      columns.push({
        title: this.$t("createTime"),
        key: "create_time",
        minWidth: 110
      });
      columns.push({
        title: "订单类型",
        key: "type",
        minWidth: 110
      });
      columns.push({
        title: this.$t("order_pcs"),
        key: "quantity",
        minWidth: 80
      });
      columns.push({
        title: this.$t("charge_params"),
        key: "actual_weight",
        minWidth: 80
      });
      columns.push({
        title: this.$t("charging_volume"),
        key: "charge_volume",
        minWidth: 80
      });
      columns.push({
        title: "申报价值",
        key: "values",
        minWidth: 80
      });
      columns.push({
        title: this.$t("order_price"),
        key: "cod_amount",
        minWidth: 80
      });
      columns.push({
        title: this.$t("from_country"),
        key: "from_country_title",
        minWidth: 80
      });
      columns.push({
        title: this.$t("target_country"),
        key: "to_country_title",
        minWidth: 80
      });
      columns.push({
        title: this.$t("city_name"),
        key: "city_name",
        minWidth: 80
      });
      if (this.shouldBlock == "CLIENT_REQUEST") {
        columns.push({
          title: this.$t("request_time"),
          key: "block_time",
          minWidth: 110,
          render: (h, params) => {
            if (params.row.block_time) {
              return h("div", [
                h("span", format.timeFormat(params.row.block_time * 1000))
              ]);
            } else {
              return h("div", [h("span", params.row.block_time)]);
            }
          }
        });
      }
      columns.push({
        title: this.$t("clientName"),
        key: "customerAccount",
        minWidth: 80
      });
      columns.push({
        title: "发件人",
        key: "shipper_name",
        minWidth: 80
      });
      columns.push({
        title: this.$t("serviceAccount"),
        key: "serviceAccount",
        minWidth: 80
      });
      columns.push({
        title: this.$t("salesman"),
        key: "staffAccount",
        minWidth: 80
      });
      columns.push({
        title: this.$t("orderType"),
        key: this.pageText == "orderIn" ? "confirmStatus" : "code_status_txt",
        minWidth: 120
      });
      // columns.push({
      //   title: this.$t("packing_number"),
      //   key: "packing_number",
      //
      //   minWidth: 150
      // });
      // columns.push({
      //   title: this.$t("bagCode"),
      //   key: "package_number",
      //
      //   minWidth: 150
      // });
      // columns.push({
      //   title: this.$t("mawb"),
      //   key: "mawb",
      //
      //   minWidth: 130
      // });
      // columns.push({
      //   title: this.$t("channel_code"),
      //   key: "transport_mode",
      //
      //   minWidth: 130
      // });

      columns.push({
        title: "长(CM)",
        key: "length",

        minWidth: 80
      });
      columns.push({
        title: "宽(CM)",
        key: "width",

        minWidth: 80
      });
      columns.push({
        title: "高(CM)",
        key: "height",

        minWidth: 80
      });
      if (this.pageText != "orderConfirm" && this.pageText != "orderWait") {
        columns.push({
          title: this.$t("check_weight"),
          key: "check_weight",

          minWidth: 80
        });
      }
      if (this.pageText == "orderIn") {
        columns.push({
          title: this.$t("confirmWeight") + this.$t("operate"),
          key: "operator_name",
          minWidth: 130
        });
        columns.push({
          title: this.$t("confirmWeight") + this.$t("time"),
          key: "operator_time",
          minWidth: 170
        });
      }
      columns.push({
        title: this.$t("order_goods"),
        key: "goods_count",
        minWidth: 80
      });
      columns.push({
        title: this.$t("order_recivre"),
        key: "consignee_contact",

        minWidth: 80
      });
      columns.push({
        title: this.$t("order_address"),
        key: "consignee_address",

        minWidth: 80
      });
      columns.push({
        title: this.$t("order_phone"),
        key: "consignee_cellular",

        minWidth: 80
      });
      columns.push({
        title: this.$t("order_refCode"),
        key: "agent_refer_code",

        minWidth: 80
      });
      columns.push({
        title: this.$t("order_desc"),
        key: "remarks",
        minWidth: 80
      });
      columns.push({
        title: this.$t("order_userRef"),
        key: "client_refer_code",
        minWidth: 80
      });
      columns.push({
        title: this.$t("print") + this.$t("time"),
        key: "print_time",
        minWidth: 110
      });
      // if (this.hideSelect) {
      //   columns.push({
      //     title: this.$t("type"),
      //     key: "type"
      //   });
      // }
      // if (this.list.length > 0) {
      //   if (this.pageText == "customerInt") {
      //     columns.push({
      //       title: this.$t("operation"),
      //       slot: "orderOperation",
      //
      //       width: 200,
      //       fixed: "right"
      //     });
      //   } else {
      //     columns.push({
      //       title: this.$t("operation"),
      //       slot: "orderOperation",
      //
      //       width: 100,
      //       fixed: "right"
      //     });
      //   }
      // }
      return columns;
    }
  },
  mounted() {
    if (this.shouldBlock) {
      this.searchFrom.should_block = this.shouldBlock;
    }
    this.searchFrom.codeStatus = this.codeStatus;
    this.getList(this.searchFrom);
    this.getOtherList();
  },
  methods: {
    copy(item) {
      copyClick.copyToClipboard(item, this);
    },
    getList(data) {
      if (data.keywords.split(/\n/).length > 15) {
        this.searchFrom.pageSize = this.arrPageSize.filter(
          item => item >= data.keywords.split(/\n/).length
        )[0];
      }
      this.loading = true;
      getOrder(data)
        .then(res => {
          if (!res.data.status) {
            this.loading = false;
            boxMes.alertMes(res, this);
            return;
          }
          this.total = res.data.payload.total;
          this.list = res.data.payload.rows.map(item => {
            item.print_time = item.print_time ? item.print_time : "未打印";
            item.interception_phase_txt = this.interceptionObj[
              item.interception_phase
            ];
            return item;
          });
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getOtherList() {
      getAllClient().then(res => {
        this.clientList = res.data.payload.rows;
      });
      getCountry({ allow_depart: 1 }).then(res => {
        this.countryList = res.data.payload.rows;
      });
      getCountry({ allow_arrive: 1 }).then(res => {
        this.toCountry = res.data.payload.rows;
      });
      getOrderType().then(res => {
        // console.log(res);
        this.orderType = res.data.payload;
      });
      getUser({ standard: "Salesman" }).then(res => {
        this.salesmanList = res.data.payload.rows;
      });
      getUser({ standard: "CustomerService" }).then(res => {
        this.serviceList = res.data.payload.rows;
      });
      getTimeType().then(res => {
        this.timeType = res.data.payload;
      });
      getAgent({ types: "DELIVERY" }).then(res => {
        this.deliverList = res.data.payload.rows;
      });
      if (this.isAll) {
        getWarehouse({ is_storage: "YES", status: "ENABLE" }).then(res => {
          this.warehouseList = res.data.payload.rows;
        });
      }
      if (this.isWarehouse) {
        getWarehouse({ is_oversea: "NO", status: "ENABLE" }).then(res => {
          this.warehouseArr = res.data.payload.rows;
        });
      }
    },
    print(item, index) {
      // let codeStatus = this.searchFrom.codeStatus;
      // if (codeStatus == 0 || codeStatus == 100) {
      //   this.$Message["error"]({
      //     background: true,
      //     content: "Current status cannot be printed"
      //   });
      //   return;
      // }
      if (this.selectAll.length == 0) {
        this.$Message["error"]({
          background: true,
          content: "Operation data cannot be empty"
        });
        return;
      }
      // let Bool = this.selectAll.some(item => {
      //   if (item.code_status == 100) return false;
      //   return true;
      // });
      // if (!Bool) {
      //   this.$Message["error"]({
      //     background: true,
      //     content: "当前状态不能打印，请检查状态"
      //   });
      //   return;
      // }
      if (index == 3) {
        let data = {
          type: item.type,
					specialLable:item.specialLable,
          merge: true,
          rule: item.rule,
          orderNo: this.selectAll.map(item => {
            return item.airway_number;
          })
        };
        postPdf(data)
          .then(res => {
            if (res.data.status) {
              window.open(this.$globalUrl + res.data.data[0].url, "_blank");
            } else {
              this.$Message["error"]({
                background: true,
                content: res.data.msg
              });
            }
          })
          .catch(err => console.log(err));
        return;
      }
      let data = {
        miniLabel: item.type,
				specialLable:item.specialLable,
        single: true,
        orders: this.selectAll.map(item => {
          return item.airway_number;
        })
      };
      postSheet(data)
        .then(res => {
          if (res.data.status) {
            window.open(res.data.payload.mergeFile, "_blank");
          } else {
            this.$Message["error"]({
              background: true,
              content: res.data.msg
            });
          }
        })
        .catch(err => console.log(err));
    },
    exportExc() {
      let data = JSON.parse(JSON.stringify(this.searchFrom));
      data.exportExcel = 1;
      data.order_id = this.selectAll.map(item => {
        return item.id;
      });
      getOrder(data).then(res => {
        if (res.data.status) {
          window.open(this.$globalUrl + res.data.payload);
        }
      });
      // this.hideSelect = true;
      // let arr = this.tableTitle;
      // arr.pop();
      // excel.exportExcel(
      //   this.selectAll.length == 0 ? this.list : this.selectAll,
      //   arr,
      //   this.$t("orderList"),
      //   this
      // );

      // this.hideSelect = false;
    },
    confirmWeightFun() {
      let airway_number = this.selectAll.map(item => {
        return item.airway_number;
      });
      console.log(airway_number);
      this.$Modal.confirm({
        title:
          this.$t("whether") +
          this.$t("confirm") +
          this.$t("selected") +
          this.$t("invoiceWeight") +
          "?",
        onOk: () => {
          confirmWeight({ airway_number }).then(res => {
            if (res.data.status) {
              this.$Message["success"]({
                background: true,
                content: this.$t("success")
              });
              this.getList(this.searchFrom);
            } else {
              this.$Message["error"]({
                background: true,
                content: res.data.msg
              });
            }
          });
        }
      });
    },
    operClick(val) {
      this.selectAll = val;
    },
    changeBindModal(val) {
      if (!val) {
        this.closedeleteModal(false);
      } else {
        this.confirm("dataDetails");
      }
    },
    closedeleteModal(e) {
      if (e === false) {
        this.isshowModal = false;
      }
    },
    confirm(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          returnPlan(this.delId, this.dataDetails).then(res => {
            boxMes.alertMes(res, this);
          });
        }
      });
    },
    crudClick(item, text) {
      this.titleModal = this.$t(text);
      this.width = 1060;
      this.unChange = true;
      this.disabled = false;
      this.dataDetails = {};
      this.preForm = {};
      this.crudText = text;
      this.footerHide = true;
      this.delId = item.airway_number;
      if (text === "show") {
        this.getDetailsList(item.airway_number);
      } else {
        this.width = 600;
        if (text == "planReturn") {
          this.footerHide = false;
          this.isshowModal = true;
        } else {
          this.statusId = item.airway_number;
          this.titleModal = item.airway_number;
          this.isshowModal = true;
        }
      }
    },
    getDetailsList(id) {
      getOrderDetails(id)
        .then(res => {
          if (!res.data.status) {
            this.$Message["error"]({
              background: true,
              content: res.data.msg,
              duration: 5
            });
            this.isshowModal = false;
            return;
          }
          this.dataDetails = res.data.payload;
          this.isshowModal = true;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getStatus(id) {
      getOrderStatus(id)
        .then(res => {
          if (!res.data.status) {
            this.$Message["error"]({
              background: true,
              content: res.data.message,
              duration: 5
            });
            this.isshowModal = false;
            return;
          }
          this.dataDetails = res.data;
          this.titleModal = this.dataDetails.awbno;
          this.isshowModal = true;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style scoped lang="less">
.delBtn {
  margin: 0 10px;
}
.ivu-page {
  margin-top: 20px;
}
.footer-modal {
  width: 100%;
  text-align: center;
}
</style>
